import { gql, useMutation } from '@apollo/client'

export const CREATE_PLAYLIST = gql`
  mutation CreatePlaylist($input: CreatePlaylistInput!) {
    createPlaylist(input: $input) {
      playlist {
        id
        title
      }
    }
  }
`

type CreatePlaylistInput = {
  title: string
  topicIds: string[]
}

type CreatePlaylistPayload = {
  playlist: {
    id: string
    title: string
  }
}

export const useCreatePlaylist = () => {
  return useMutation<{ createPlaylist: CreatePlaylistPayload }, { input: CreatePlaylistInput }>(
    CREATE_PLAYLIST,
    {
      refetchQueries: ['GetPlaylist'],
    },
  )
}
